<template>
  <el-dialog
    class="checkcode-dialog"
    :width="width"
    :before-close="emitClose"
    :title="title"
    :visible.sync="visible"
    @open="handleOpen">
    <div class="content">
      <slot name="header-tips"></slot>
      <div class="inputs">
        <div style="display:flex;align-items:center;">
          <el-input v-model="tel" size="small" placeholder="请输入手机号" :disabled="!mobileCanEdit" clearable />
          <el-button
            type="success"
            size="small"
            style="margin-left:10px;"
            :disabled="requestButtonDisabled"
            @click="requestCheckcode">获取验证码</el-button>
        </div>
        <p v-if="showMobileTips" class="tips error">{{ mobileErrorTips }}</p>
        <el-input v-model="checkcode" size="small" placeholder="请输入验证码" clearable style="margin-top:22px;" />
        <p v-if="showSendSucceedTips" class="tips success">{{ sendSucceedTips }}</p>
        <p v-if="!showSendSucceedTips && showSendFailedTips" class="tips error">{{ sendFailedTips }}</p>
      </div>
    </div>
    <span slot="footer">
      <el-button type="success" @click="confirm">{{ confirmButtonText }}</el-button>
      <el-button type="info" @click="emitClose">{{ cancelButtonText }}</el-button>
    </span>
  </el-dialog>
</template>

<script>
// TODO: 临时处理, 后期需要分离如获取验证码这类通用接口
// import axios from 'axios'
import { sendMobileMessge } from '@/model/customer-manager-model'

export default {
  name: 'CheckcodeDialog',
  props: {
    visible: { // dialog 的可见性
      type: Boolean,
      required: true
    },
    title: { // dialog 的 title
      type: String,
      default: '短信验证码'
    },
    mobile: { // 接收短信验证码的手机号
      type: String,
      default: ''
    },
    mobileCanEdit: { // 手机号可以修改(默认可以修改, 某些情况下不可修改)
      type: Boolean,
      default: true
    },
    width: { // 弹窗的宽(http://element-cn.eleme.io/#/zh-CN/component/dialog)
      type: String,
      default: '555px'
    },
    interval: { // 再次发送验证码的时间间隔(单位: 秒)
      type: Number,
      default: 30
    },
    confirmButtonText: {
      type: String,
      default: '确 定'
    },
    cancelButtonText: {
      type: String,
      default: '取 消'
    },
    checkcodeHttpRequest: { // 获取验证码的接口
      type: Function,
      default (params = {}) {
        return sendMobileMessge(params)
      }
    }
  },
  data () {
    return {
      checkcode: '',
      showMobileTips: false,
      mobileErrorTips: '',
      timer: null,
      requestButtonDisabled: false,
      tel: this.mobile,
      leftTime: this.interval,
      showSendSucceedTips: false, // 显示发送结果提示(发送成功 or 发送失败)
      showSendFailedTips: false, // showSendFailedTips !== !showSendSucceedTips
      sendFailedTips: '短信验证码发送失败，请稍候重试！'
    }
  },
  computed: {
    sendSucceedTips () {
      return `短信验证码发送成功！ ${this.leftTime} 秒后可再次发送。`
    }
  },
  watch: {
    mobile (value) {
      this.tel = value
    },
    leftTime (time) {
      if (time <= 0) {
        this.showSendSucceedTips = false
      }
    }
  },
  methods: {
    beginCountDown () {
      clearInterval(this.timer)
      this.timer = setInterval(() => {
        if (this.leftTime > 0) {
          this.leftTime--
        } else {
          clearInterval(this.timer)
          this.requestButtonDisabled = false
        }
      }, 1000)
    },
    // 检查是否可以发送验证码
    checkCanRequestCheckcode () {
      let mobile = this.tel
      // 首先检查是否有手机号码
      if (mobile === '') {
        this.mobileErrorTips = '手机号码不能为空！'
        this.showMobileTips = true
        return false
      }
      // 检查手机号码格式
      if (!/^1\d{10}$/.test(mobile)) {
        this.mobileErrorTips = '手机号码格式不正确！'
        this.showMobileTips = true
        return false
      }
      // 检查时间间隔
      this.showMobileTips = false
      return true
    },
    emitClose () {
      this.$emit('checkcode-dialog-close')
    },
    // 请求发送验证码
    requestCheckcode () {
      if (!this.checkCanRequestCheckcode()) {
        return
      }
      this.requestButtonDisabled = true
      this.checkcodeHttpRequest({
        data: { mobilePhone: this.tel }
      }).then(res => {
        console.log(res)
        if (res.result === 'true') {
          this.showSendSucceedTips = true
          this.leftTime = this.interval
          this.beginCountDown()
        } else {
          this.showSendSucceedTips = false
          this.showSendFailedTips = true
          this.requestButtonDisabled = false
        }
      })
    },
    confirm () {
      if (this.checkcode === '') {
        this.mobileErrorTips = '请输入验证码!'
        this.showMobileTips = true
      } else {
        this.mobileErrorTips = ''
        this.showMobileTips = false
        this.$emit('checkcode-dialog-confirm', {
          checkcode: this.checkcode,
          phoneNum: this.tel
        })
      }
    },
    handleOpen () {
      this.checkcode = ''
      this.mobileErrorTips = ''
      this.showMobileTips = false
      if (!this.mobileCanEdit && this.mobile === '') {
        console.error(`[CheckcodeDialog warn]: if prop "mobile-can-edit" is false, prop "mobile" shouldn't be empty!`)
      }
    }
  }
}
</script>

<style lang="scss">
.checkcode-dialog {
  // .el-dialog__body {
  //   background: #FBFDFC;
  //   padding: 30px;
  // }

  // .el-dialog__footer {
  //   background: #FBFDFC;
  //   padding-top: 0;
  //   padding-bottom: 30px;
  // }

  .content {

    .tips {
      margin: 0;
      font-size: 12px;

      &.error {
        color: #FF1111;
      }

      &.success {
        color: #468F46;
      }
    }
  }

  .inputs {
    width: 300px;
    margin: 0 auto;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/custom/CheckcodeDialog.vue